import { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import SuspenseLoader from "../Components/Loaders/SuspenseLoader";
import GroceriesPage from "../pages/Groceries";
import NotFoundPage from "../pages/NotFound";
import Grocery from "../pages/Grocery";

const Routes = () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/groceries" />
        </Route>
        <Route path="/groceries" exact>
          <GroceriesPage />
        </Route>
        <Route path="/groceries/:groceryID" exact>
          <Grocery/>
        </Route>
        <Route path="*">
          <NotFoundPage />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Routes;
